$(document).ready(() => {
  $('.form-field .wpcf7-form-control, .sib-email-area input').each(function () {
    if (!$(this).val()) {
      $(this).parent().parent().removeClass('filled')
    } else {
      $(this).parent().parent().addClass('filled')
    }

    $(this).on('focus', function () {
      $(this).parent().parent().addClass('filled')
      $(this).parent().parent().addClass('active')
    })

    $(this).on('blur', function () {
      if (!$(this).val()) {
        $(this).parent().parent().removeClass('filled')
        $(this).parent().parent().addClass('empty')
      }
      $(this).parent().parent().removeClass('active')
    })
  })

  const dateField = $('.form-field-date .wpcf7-form-control')
  if(dateField.length > 0){
    dateField.datepicker({
      onSelect: animateInput
    })
  }
})

document.addEventListener('wpcf7mailsent', () => {
  const fieldList = document.querySelectorAll('.wpcf7-form .form-row .form-field:not(.no-anim)')
  if(fieldList.length) {
    fieldList.forEach((field) => {
      if(field.classList.contains('filled')){
        field.classList.remove('filled')
      }
      if(field.classList.contains('active')){
        field.classList.remove('active')
      }
      if(!field.classList.contains('empty')){
        field.classList.add('empty')
      }
    })
  }
})


function animateInput(dateText, datepicker) {
  $(this).parent().parent().addClass('filled')
}

